module.exports = __webpack_public_path__ + "img/AppStore.db438f97.jpg";